/**
 * Определение темы и платформы
 * # ⛓️ CURSOR_ANCHOR:ui:theme-detection
 */

(function() {
  'use strict';

  var THEME_LIGHT = window.THEME_CONSTANTS.LIGHT;
  var THEME_DARK = window.THEME_CONSTANTS.DARK;
  var THEME_AUTO = window.THEME_CONSTANTS.AUTO;

  /**
   * Определить, является ли платформа Windows
   */
  function isWindows() {
    var ua = navigator.userAgent || navigator.vendor || window.opera;
    return /windows|win32|win64/i.test(ua);
  }

  /**
   * Определить, какая тема должна быть активна
   */
  function getEffectiveTheme() {
    var stored = window.THEME_STORAGE.get();
    if (stored === THEME_AUTO) {
      // Проверяем системную тему (работает на iOS, macOS, Android)
      try {
        if (window.matchMedia) {
          var mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
          // Проверяем matches (может быть не поддерживается на старых iOS)
          if (mediaQuery && mediaQuery.matches) {
            return THEME_DARK;
          }
        }
      } catch (e) {
        // Игнорируем ошибки определения темы
      }
      return THEME_LIGHT;
    }
    return stored;
  }

  /**
   * Получить следующую тему в цикле переключения
   */
  function getNextTheme(currentTheme) {
    // Цикл переключения для всех платформ: светлая -> темная -> авто -> светлая
    if (currentTheme === THEME_LIGHT) {
      return THEME_DARK;
    } else if (currentTheme === THEME_DARK) {
      return THEME_AUTO;
    } else {
      return THEME_LIGHT;
    }
  }

  window.THEME_DETECTION = {
    isWindows: isWindows,
    getEffective: getEffectiveTheme,
    getNext: getNextTheme
  };
})();

